import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Message } from 'primereact/message';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioArchivos from '../servicios/ServicioArchivos';
import { CALENDARIO_ES_MX } from '../servicios/ServicioConstantes';

export class ReporteFacturacionMensual extends Component {
    constructor() {
        super();
        this.state = {
            emisores: [
                { label: "CPF6307036N8", value: "CPF6307036N8" },
                { label: "FNI970829JR9", value: "FNI970829JR9" },
                { label: "FNI970829JR9-Puebla", value: "FNI970829JR9-Puebla" }
            ],
            reporte: {},
            errores: {}
        };
    }

    generarReporte = () => {
        let { reporte } = this.state;
        let errores=this.validarFormulario(reporte);
        this.setState({errores});
        if (servicioAsignacionValoresObjetos.esObjetoVacio(errores)){
            let urlReporte='/cfdi/reporte_facturacion_mensual.json';
            if(reporte.rfcEmisor==='FNI970829JR9-Puebla'){
                urlReporte='/cfdi/reporte_facturacion_mensual_puebla.json';
            }
            servicioArchivos.descargaArchivo(urlReporte, reporte, this);
        }    
    }

    validarFormulario = (reporte) => {
        let errores = {};
        if (servicioAsignacionValoresObjetos.esObjetoVacio(reporte.rfcEmisor))
            errores.rfcEmisor = "Elige un rfc";
        if (servicioAsignacionValoresObjetos.esObjetoVacio(reporte.fechaInicial))
            errores.fechaInicial = "Elige fecha inicial";
            if (servicioAsignacionValoresObjetos.esObjetoVacio(reporte.fechaFinal))
            errores.fechaFinal = "Elige fecha final";
        return errores;
    }

    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    }


    render() {
        let { reporte, emisores, errores } = this.state;

        return (
            <div className="card">
                <h1>Reporte de Facturación Mensual</h1>
                <p>En esta sección se puede obtener los reportes de facturación de cada mes.</p>
                <div className="p-grid">
                    <div className="p-col-12 p-md-4">
                        <label className="title__input-label">Emisor:</label>
                        <Dropdown style={{ 'width': '80%' }}
                            id="reporte.rfcEmisor" name="reporte.rfcEmisor" options={emisores}
                            value={reporte.rfcEmisor}
                            onChange={this.asignarValoresObjeto}
                            className={errores.rfcEmisor ? 'p-error' : ''}
                            autoWidth={false} optionValue="value" />
                        {errores.rfcEmisor ? <div><br /> <Message severity="error" text={errores.rfcEmisor} /> </div> : null}
                    </div>
                    <div className="p-col-12 p-md-4">
                        <label className="title__input-label">Fecha Inicial:</label>
                        <Calendar appendTo={document.body} id="reporte.fechaInicial" name="reporte.fechaInicial"
                            value={reporte.fechaInicial || ''} onChange={this.asignarValoresObjeto}
                            locale={CALENDARIO_ES_MX} className={errores.mes ? 'p-error' : ''}></Calendar>
                        {errores.fechaInicial ? <div><br /> <Message severity="error" text={errores.fechaInicial} /> </div> : null}    
                    </div>

                    <div className="p-col-12 p-md-4">
                        <label className="title__input-label">Fecha Final:</label>
                        <Calendar appendTo={document.body} id="reporte.fechaFinal" name="reporte.fechaFinal"
                            value={reporte.fechaFinal || ''} onChange={this.asignarValoresObjeto}
                            locale={CALENDARIO_ES_MX} className={errores.mes ? 'p-error' : ''}></Calendar>
                        {errores.fechaFinal ? <div><br /> <Message severity="error" text={errores.fechaFinal} /> </div> : null}    
                    </div>
                    <div className="p-col-12 p-md-4">
                        <Button label="Generar Reporte" icon="pi-md-search" className="p-button-success" onClick={this.generarReporte} />
                    </div>

                </div>
            </div>
        );
    }
}